import cx from 'classnames'
import Link from 'components/Link'
import styles from './ContentLabel.sass'
import * as React from 'react'

interface ContentLabelProps {
  children?: React.ReactNode
  clickable?: boolean
  onClick?: () => unknown
  iconRight?: React.ReactNode
  block?: boolean
  labelRef?: React.LegacyRef<HTMLElement | null>
  /**
   * Optional actions using <ContentLabelAction />
   */
  actions?: React.ReactNode
}

/**
 " Content Label
 */
export function ContentLabel({
  children,
  clickable,
  block,
  onClick,
  iconRight,
  actions,
  labelRef,
}: ContentLabelProps) {
  return (
    <div className={cx(styles.root, block && styles.block)}>
      <div
        className={cx(styles.label, (clickable || onClick) && styles.clickable)}
        onClick={onClick}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: no contravariance
        ref={labelRef}
      >
        <div className={styles.text}>{children}</div>
        {iconRight && <span className={styles.icon}> {iconRight}</span>}
      </div>

      <div className={styles.actions}>{actions}</div>
    </div>
  )
}

interface ContentLabelActionProps {
  children?: React.ReactNode
  to?: string
  href?: string
  onClick?: () => unknown
}

/**
 " Content Label Action
 */
export function ContentLabelAction({
  children,
  to,
  href,
  onClick,
}: ContentLabelActionProps) {
  return (
    <Link to={to} href={href} className={styles.action} onClick={onClick}>
      {children}
    </Link>
  )
}
